export const gold = "#C6A664";
